export const DataCollectionSection = () => (
  <section>
    <h2>1. Data Collection & Processing</h2>

    <p>
      (i) Customer Data: Our Services enable Volca customers to run custom
      referral programs from their phones (collectively, "Customer Data").
    </p>

    <p>
      Customer Data may contain data which relates to identifiable individuals,
      such as the customer's sales representatives, prospects, and other parties
      either taking part in their communications or mentioned there.
    </p>

    <p>
      Volca processes Customer Data, and the personal data contained in it,
      strictly on our customer's behalf, in accordance with their reasonable
      instructions and as further stipulated in our Data Processing Addendum and
      other commercial agreements with such customer.
    </p>

    <p>
      Accordingly, to the extent that the EU's General Data Protection
      Regulation (GDPR), California Consumer Privacy Act (CCPA), UK Data
      Protection Act (UKDPA) or any similar laws apply, our customer will be
      deemed the 'data controller' (under the GDPR, UKDPA and similar laws) or
      'business' (under the CCPA or similar laws) of such Customer Data; and
      Volca will be deemed the 'data processor' or 'service provider' when
      processing such data.
    </p>

    <p>
      (ii) Volca User Data: We collect and generate the following types of
      personal data concerning users of our Platform –user account information
      (e-mail address and, when applicable, hashed password);
    </p>

    <p>
      profile and contact information (name, title, team, company, e-mail and
      phone number, and additional information and media submitted by them,
      their teammates or their organization);
    </p>

    <p>
      Platform usage information (connectivity, technical and aggregated usage
      data, such as user agent, IP addresses, device data (like type, OS, device
      id, browser version, locale and language settings used), activity logs,
      and the cookies installed or utilized on their device; and
    </p>

    <p>
      direct interactions and communications with us (including recordings and
      transcripts of your calls and emails with us, e.g. for user enablement,
      support and training purposes).
    </p>

    <p>
      Whilst Volca processes such Volca User Data on its customers' behalf
      (where it is included in Customer Data), we also use it for our own
      purposes, as described in Section ‎2 below. Accordingly, to the extent
      applicable – our customer will be deemed the 'data controller' or
      'business' with respect to such data; Volca will also be deemed an
      independent and separate 'data controller' or 'business' with respect to
      such data; and with respect to those portions or copies of Volca User Data
      that we process on behalf of our customer – we will also be deemed a 'data
      processor' or 'service provider'.
    </p>

    <p>
      (iii) Volca Website, CRM & Prospect Data: We collect and generate the
      following types of personal data concerning our website visitors,
      customers and prospects –
    </p>

    <p>
      Website usage information (connectivity, technical and aggregated usage
      data, such as user agent, IP addresses, device data (like type, OS, device
      id, browser version, locale and language settings used), activity logs,
      session recordings, and the cookies and pixels installed or utilized on
      their device;
    </p>

    <p>
      Customer account information (contact, contractual and billing details
      concerning our customers, which may also contain the details of their
      internal focal persons who directly engage with Volca concerning their
      organizational account, e.g. the account administrators, billing contacts
      and authorized signatories on behalf of the customer; as well as the
      customer's needs and preferences, as identified to us or recognized
      through our engagement with them);
    </p>

    <p>
      Information concerning our customers and prospects (contact and business
      details, our communications with such customers and prospects
      (correspondences, call and video recordings, and analyses thereof), as
      well as any needs, preferences, attributes and insights relevant to our
      potential engagement).
    </p>

    <p>
      We collect such data either automatically, through the data subject's
      interaction with us or with our website, Platform or Services; or through
      third party services, social media, analytics tools, events we organize or
      participate in, and other business initiatives.
    </p>
  </section>
);
